const SDK = require('furioos-sdk')
const Player = SDK.Player

const furioosAspectRatio = 1.77777778 // 16:9

// const furioosInstanceId = '882.431' // localhost:8080
const furioosInstanceId = '864.935' // pose-xr.com

const furioosContainerId = 'furioos_container'

export default {
  data() {
    return {
      player: null,
      playerState: 'waiting',
      playerLoadingProgress: 0,
      playerUserState: 'waiting',
      playerLaunched: false,
      playerLaunchTimeout: null,
      playerLaunchTimeoutDelay: 3000,
      playerServerAvailabilityResponse: null,
      playerHasTimedOut: false,
      isStreamStarted: false,

      innerWidth: null,
      innerHeight: null,

      eventLog: [],
      logSDKMessages: true,

      gallery: [],
    }
  },

  mounted() {
    this.checkWindowSize()
    // this.setupFurioos()
  },

  created() {
    window.addEventListener('resize', this.checkWindowSize)
  },
  destroyed() {
    window.removeEventListener('resize', this.checkWindowSize)
  },

  watch: {
    isStreamStarted(state) {
      if (state && !this.playerLaunched && this.playerReadyForLaunch) {
        this.playerLaunchTimeout = setTimeout(() => {
          this.launchPlayer()
        }, this.playerLaunchTimeoutDelay)
      }
    },

    // playerUserState(state) {
    //   if (state === 'inactive') {
    //     this.playerLaunched = false
    //     this.player = null
    //   }
    // },

    playerState(state) {
      if (state === 'stopped') {
        this.playerHasTimedOut = true
        this.playerLaunched = false
        this.player = null
        this.clearPlayer()
      }
    },
  },

  methods: {

    onSDKMessageReceived (data) {
      if(data.startsWith('Received: ')) {
        // This is a bounce back confirmation the server received the message. 
        // Ignore
        return 
      } else {
        // Furioos prepends the body of the sdk message with 'Received: ' ..
        try {
          let obj = JSON.parse(data)
          this.handleSDKBody(obj)
        } catch(e) {
          console.error('Failed to parse SDK Message', e, data)
        }
      }

    },

    handleSDKBody (body) {
      // console.log('Got valid SDK message', body)

      if(body.serverEvent !== undefined) {
        if(body.serverEvent === 'OnCaptureComplete' && body.capture !== undefined) { 
          this.onSDKCaptureComplete(body.capture)
        }

        // if(body.serverEvent === 'OnSettingUpdateComplete' && body.state !== undefined) { 
        //   this.onSDKSettingUpdate(body.state)
        // }
      }
    },

    // onSDKSettingUpdate (state) {
    //   console.log('STATE UPDATED', state)
    // },

    onSDKCaptureComplete (capture) {
      let data = {
        id: capture.id,
        uri: 'https://serverlessrepo-serverless-s3-uploader-s3bucket-1g5qdupqx9vp5.s3.eu-west-2.amazonaws.com/' + capture.id,
        thumbnail: 'https://serverlessrepo-serverless-s3-uploader-s3bucket-1g5qdupqx9vp5.s3.eu-west-2.amazonaws.com/' + capture.id 
      }

      this.gallery.push(data)
    },

    sendSDKUpdateStateMessage (value) {
      // @todo - send sdk message down
      if(!value.isArray) value = [value]

      let message = {
        'updateState': value
      }

      this.sendSDKMessage(message)
    },

    sendSDKRequestCaptureMessage (e) {
      let message = {
        'requestCapture': true
      }

      this.sendSDKMessage(message)
    },

    sendSDKMessage(message) {
      if(this.player === null) {
        console.warn('Message requested to send to SDK skipped. Player is null', message)
        return
      }

      if(this.logSDKMessages) console.log('Sending message SDK', message)

      this.log('Sent SDK Message', message)
      this.player.sendSDKMessage(message)
    },

    clearPlayer() {
      this.player = null
    },

    clearPlayerStates() {

      if(this.playerHasTimedOut) {
        // Also clear the container of any left over elements 
        // ie, the furioos iframe. 
        // When furioos reinit's it'll re-add anything it needs
        const container = this.$refs.furioosContainer
        container.innerHtml = ''
      }

      this.playerServerAvailabilityResponse = null
      this.playerHasTimedOut = false
      this.playerUserState = 'waiting'
      this.playerLoadingProgress = 0

    },

    launchPlayer() {
      this.playerLaunched = true
    },

    checkWindowSize() {
      this.innerHeight = window.innerHeight
      this.innerWidth = window.innerWidth
    },

    setupFurioos() {
      if (this.player !== null) return

      this.log('Furioos Setup')

      this.clearPlayerStates() // reset back to start state

      const player = new Player(furioosInstanceId, furioosContainerId, {
        whiteLabel: true,
        hideTitle: true,
        hideToolbar: false,
        hidePlayButton: false,
        debugAppMode: false,
        // overridedURL: 'http://localhost:8080'
      })

      this.player = player

      player.onLoad(() => {
        this.log('Furioos onLoad event')
        this.playerState = 'starting'
        this.start()
      })

      player.onAppInstallProgress(data => {
        this.playerState = data.status.toLowerCase()
        this.playerLoadingProgress = data.progress
      })

      player.onAppInstallSuccess(() => {
        this.playerState = 'installed'
      })

      player.onAppInstallFail(() => {
        this.playerState = 'failed'
      })

      player.onAppStart(() => {
        this.playerState = 'started'

        this.log('Furioos onAppStart')
      })
      player.onStreamStart(() => {
        this.isStreamStarted = true
      })

      player.onUserActive(() => {
        this.playerUserState = 'active'
      })

      player.onUserInactive(() => {
        this.playerUserState = 'inactive'
        this.log('Furioos onUserInactive')
      })

      player.onSessionStopped(() => {
        this.playerState = 'stopped'
        this.log('Furioos onSessionStopped')
      })

      // Bind SDK messages
      player.onSDKMessage((data) => {
        this.onSDKMessageReceived(data)
      })

      // player.onStats(function(stats) {
      //   console.log('Stats received: ', stats)
      // })
    },

    start() {
      this.player.getServerAvailability(
        data => {
          this.playerServerAvailabilityResponse = data
          this.log('Player start requested')
          this.player.start()
        },
        error => {
          this.playerServerAvailabilityResponse = error

          this.clearPlayer()
        }
      )
    },

    log(message, extra) {
      this.eventLog.push({
        message: message,
        extra: extra,
        time: Date.now(),
      })
    },
  },

  computed: {
    logStartTime() {
      if (this.eventLog.length < 1) return Date.now()
      return this.eventLog[0].time
    },

    playerHasServerAvailabilityError() {
      if (this.playerServerAvailabilityResponse === null) return false
      if (this.playerServerAvailabilityResponse.error !== undefined) return true
      return false
    },

    playerStateMessage() {
      if (this.playerState === 'waiting') {
        if (this.player === null) return 'Ready to start'
        return 'Launching'
      }

      if (this.playerState === 'starting') return 'Starting up'

      if (
        this.playerState === 'copying' ||
        this.playerState === 'decompressing'
      )
        return 'Installing'

      return 'wait..'
    },

    playerReadyForSetup() {
      return this.player === null
    },

    playerReadyForLaunch() {
      return this.playerState === 'started' && this.playerLaunched === false
    },
    /*
      The furioos system forces the iframe video internals to output to a 16:9 ratio, which adds black bars top/bottom on (mobile first) design
      We can't force furioos to output to the ratio we want, so instead we'll trick the iframe into underlapping the page
      Then the unity project camera adjusts to keep the visible portion correct for the clipped viewport on page.
      */
    furioosIframeContainerStyle() {
      if (this.isStreamStarted !== true && this.forceShowUI === false) return null
      if (this.pageAspectRatio === furioosAspectRatio) return null // Magic. (also doubtful)

      let width = this.innerWidth
      let height = this.innerHeight
      let leftOffset = 0
      let topOffset = 0

      if (this.pageAspectRatio < furioosAspectRatio) {
        // ie, the page is more portrait than 16:9
        width = height * furioosAspectRatio
        leftOffset = ((width - this.innerWidth) / 2) * -1
      } else {
        // ie. the page is more landscape than 16:9
        height = width * furioosAspectRatio
        topOffset = ((height - this.innerHeight) / 2) * -1
      }

      return {
        position: 'absolute',
        width: width + 'px',
        height: height + 'px',
        top: topOffset + 'px',
        left: leftOffset + 'px',
      }
    },

    pageAspectRatio() {
      return this.innerWidth / this.innerHeight
    },
  },
}
